import { CustomColumn } from '../../../../types/customColumn';

export const consumerFinalProductColumns: CustomColumn<any>[] = [
  {
    Header: '#',
    id: 'rowIndex',
    accessor: 'id',
    customCell: (cell: any) => {
      const index = cell.row.index;
      const { pageIndex = 0, pageSize = 10 } = cell.table?.state || {};
      return pageIndex * pageSize + index + 1;
    },
  },

  {
    Header: 'Producto',
    accessor: 'productName',
    customCell: ({ row }) => {
      const { productCode, productName, categoryName } = row.original;
      return (
        <div className="text-sm leading-6">
          {/* Código del producto */}
          <div className="font-mono text-gray-500 dark:text-gray-400 text-xs">
            {productCode ? `(${productCode})` : '—'}
          </div>
          {/* Nombre */}
          <div className="font-medium text-black dark:text-white">
            {productName}
          </div>
          {/* Categoría (misma caja/clases, ahora en dos líneas) */}
          <div className="text-gray-600 dark:text-gray-400 mt-1 text-xs">
            <div>
              <strong>CATEGORÍA:</strong>
            </div>
            <div>{categoryName || '—'}</div>
          </div>
        </div>
      );
    },
  },

  {
    Header: 'Cantidad',
    accessor: 'quantity',
    customCell: ({ row }) => {
      const { quantity, unit } = row.original;
      return (
        <div className="text-sm leading-6">
          {Number(quantity || 0).toFixed(2)} {unit || ''}
        </div>
      );
    },
  },
  {
    Header: 'Precio Unitario',
    accessor: 'unitPrice',
    customCell: ({ value }) => (
      <div className="text-sm leading-6">${Number(value || 0).toFixed(2)}</div>
    ),
  },
  {
    Header: 'Descuento',
    accessor: 'discount',
    customCell: ({ value }) => {
      const discount = Number(value || 0);
      return (
        <div
          className={`text-sm leading-6 ${
            discount > 0 ? 'text-red-600' : 'text-gray-800 dark:text-gray-200'
          }`}
        >
          {discount > 0 ? `-$${discount.toFixed(2)}` : '$0.00'}
        </div>
      );
    },
  },
  {
    Header: 'IVA',
    accessor: 'vat',
    customCell: ({ value }) => (
      <div className="text-sm leading-6">${Number(value || 0).toFixed(2)}</div>
    ),
  },
  {
    Header: 'Total',
    accessor: 'taxedAmount',
    customCell: ({ value }) => (
      <div className="text-sm font-medium leading-6">
        ${Number(value || 0).toFixed(2)}
      </div>
    ),
  },
];
